import React from 'react';
import { Route, Redirect } from 'react-router';
import App from 'shared/App.jsx';
import { BASE_PATH } from 'shared/variables';

// feature routes
import AuthRoutes from './features/shared/auth/routes';
import AdminRoutes from './features/admin/routes';
import FinanceRoutes from './features/finance/routes';
import TournamentRoutes from './features/tournament/routes';
import RegistrationRoutes from './features/registration/routes';
import SharedRoutes from './features/shared/routes';
import AboutRoutes from './features/about/routes';

import store from 'store';
import { signinRedirectCallback, signinSilentCallback } from 'shared/auth/actions.js';

export default (
  <div>
    <Route
      path={`${BASE_PATH}/signin/callback`}
      onEnter={() => store.dispatch(signinRedirectCallback())}
    />
    <Route
      path={`${BASE_PATH}/signin/silentrenew`}
      onEnter={() => signinSilentCallback()}
    />
    <Route
      path={`/${BASE_PATH}`}
      component={App}
    >
      <Redirect
        from="/"
        to={`/${BASE_PATH}`} />
      {AuthRoutes}
      {RegistrationRoutes}
      {TournamentRoutes}
      {AdminRoutes}
      {FinanceRoutes}
      {AboutRoutes}
      {SharedRoutes}
    </Route>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes.js